module.exports = __webpack_public_path__ + "static/media/image-5.3432b448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/WebsiteVsSocialMediaPages/image-5.jpg
// module id = 422
// module chunks = 0